import { render, staticRenderFns } from "./SelectServicePage.vue?vue&type=template&id=2891e17a&scoped=true&"
import script from "./SelectServicePage.vue?vue&type=script&lang=js&"
export * from "./SelectServicePage.vue?vue&type=script&lang=js&"
import style0 from "./SelectServicePage.vue?vue&type=style&index=0&id=2891e17a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891e17a",
  null
  
)

export default component.exports